import Project1 from "../../assets/project1.gif";
import Project2 from "../../assets/project2.webp";
import Project3 from "../../assets/project3.webp";


export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "open-world-pygames",
        category: "A",
    },
    {
        id: 2,
        image: Project2,
        title: "Rendering-Web_chat ",
        category: "B",
    },
    {
        id: 3,
        image: Project3,
        title: "work with OpenStreetMap",
        category: "C",
    },
];

export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "A",
    },
    {
        name: "B",
    },
    {
        name: "C",
    },
];